import { useContext } from "react";
import { GlobalContextData } from "../context";
import { UserRole } from "../constants";

export const useUserRole = (): UserRole | null => {
  const { state } = useContext(GlobalContextData);
  const role = state.userInfo?.["custom:roleName"];
  return role ? (role as UserRole) : null;
};
